import StyledItem from './StyledItem';

import './StyledItem.scss';

export default StyledItem;
